import styled from "styled-components";

export const Container = styled.main`
    display: flex;
    flex-direction: column;
    margin-top: 75px;
    padding: 0 10px;
    width: 100%;
    @media (min-width: 720px) {
        margin: 40px 0 0 200px;
        padding: 0;
    }
    @media (orientation: landscape) and (max-width: 1080px){
        margin-left: 25px;
        padding: 0;

    }
`;

export const SubTitle = styled.h2`
    font-size: 14px;
    text-align: left;
    color: #333;
    font-weight: 700;
    padding-top: 15px;
    padding-bottom: 10px;
    @media (min-width: 720px) {
        font-size: 20px
    }
    @media (orientation: landscape) and (max-width: 1080px){
        font-size: 14px;
    }
`;

export const TimeSpend = styled.div`
    display: flex;
    flex-direction: row;
    gap: 10px;
    height: 200px;
    padding-inline: 15px;
`;

export const ScaleContainer = styled.div`
    align-items: flex-end;
    align-self: center;
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: space-between;
    padding-bottom: 20px;
    @media (min-width: 720px) {
        padding-bottom: 30px;
    }
    @media (orientation: landscape) and (max-width: 1080px){
        padding-bottom: 20px;
    }
`;

export const HourText = styled.span`
    font-size: 12px;
    font-weight: 500;
    @media (min-width: 720px) {
        font-size: 16px
    }
    @media (orientation: landscape) and (max-width: 1080px){
        font-size: 12px;
    }
    
`;

export const ScrollContainer = styled.div`
    display: flex;
    flex-direction: row;
    gap: 10px;
    overflow: auto;
`;

export const ScrollColumnContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
    overflow: auto;
`;

export const HeaderContainer = styled.div`
    align-items: center;
    display: flex;
    flex-direction: column;
    gap: 20px;
    justify-content: flex-start;
    padding: 20px;
    @media (min-width: 720px) {
        display: flex;
        flex-direction: row;
        height: 180px;
        padding: 0px 20px 20px 0px;
    }
`;

export const ContainerStats = styled.div`
    display: flex;
    flex-direction: row;
`;

export const TypeText = styled.span`
    color: #464646;
    display: flex;
    font-size: 14px;
    font-weight: 700;
    justify-content: space-between;
    padding-inline: 15px;
    width: 100%;
    @media (min-width: 720px) {
        font-size: 20px
    }
    @media (orientation: landscape) and (max-width: 1080px){
        font-size: 14px;
    }
`;

export const TypeContainer = styled.div`
    align-items: flex-start;
    display: flex;
    flex-direction: column;
    gap: 10px;
    height: 100%;
    justify-content: center;
`;

export const Line = styled.div`
    background: #C7C7C7;
    display: flex;
    height: 1px;
    width: 100%;
    @media (min-width: 720px) {
        height: 3px;
    }
    @media (orientation: landscape) and (max-width: 1080px){
        height: 1px;
    }
`;

export const TypeValue = styled.span`
    color: #464646;
    display: flex;
    font-size: 14px;
    font-weight: 500;
    padding-inline: 15px;
    text-align: right;
    @media (min-width: 720px) {
        font-size: 20px
    }
    @media (orientation: landscape) and (max-width: 1080px){
        font-size: 14px;
    }
`;

export const ReportGraph = styled.div`
    display: flex;
    flex-direction: column;
    min-width: 450px;
`;

export const ReportBox = styled.div`
    display: flex;
    flex-direction: column;
`;

export const ReportsContainer = styled.div`
    display: flex;
    flex-direction: column;
    padding-inline: 20px;
    width: 100%;
    @media (min-width: 720px) {
        flex-direction: row;
        padding: 0;
    }
    @media (orientation: landscape) and (max-width: 1080px){
        flex-direction: column;
        padding: 0;
    }
`;  